import { useState } from 'react';
import { Tooltip, Button } from '@cimpress/react-components';

interface Profile {
  email?: string;
  name?: string;
  picture?: string;
  domain?: string;
  sub?: string;
}

const UserAvatar = ({ username }: { username: string }) => {
  const initial = username.charAt(0).toUpperCase();
  return (
    <div
      style={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        background: '#3b82f6',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        fontSize: 14,
      }}
    >
      {initial}
    </div>
  );
};

const LoginAvatar = ({
  isUserLoggedIn,
  onLogout,
  profile,
}: {
  isUserLoggedIn: boolean;
  onLogout: () => void;
  profile: Profile | undefined;
}) => {
  const username = profile?.name || 'User';
  const [showPopover, setShowPopover] = useState(false);

  return (
    <div
      style={{
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
      }}
    >
      {isUserLoggedIn ? (
        <Tooltip
          direction="bottom"
          variant="popover"
          contents={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                padding: 16,
              }}
            >
              <UserAvatar username={username} />
              <h4 style={{ margin: '8px 0 4px' }}>{username}</h4>
              <p style={{ margin: '0 0 12px', fontSize: 12, color: '#6b7280' }}>
                {profile?.email}
              </p>
              <Button variant="primary" color="danger" onClick={onLogout}>
                Logout
              </Button>
            </div>
          }
          show={showPopover}
          onClickOutside={() => setShowPopover(false)}
        >
          <button
            className="userAvatar"
            data-testid="header-user-profile"
            onClick={() => setShowPopover(!showPopover)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
            }}
          >
            <UserAvatar username={username} />
          </button>
        </Tooltip>
      ) : (
        <button>Login</button>
      )}
    </div>
  );
};

export default LoginAvatar;
